import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getInvoiceLogs } from '@/modules/Invoice/services'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Typogaphy } from 'vnetwork-ui'
import { getInvoiceUpdateColumns } from './columns'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'

const ListInvoiceUpdate = () => {
    const { id } = useParams()
    const { t } = useTranslation()

    const invoiceId = Number(id)

    const [payload, setPayload] = useState<DataGridPayload>({
        page: 1,
        page_size: 10,
        q: '',
    })
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.INVOICE_LOGS, invoiceId],
        queryFn: () => getInvoiceLogs({ ...payload, invoiceId }),
    })

    const rows = data?.results || []
    const columns = useMemo(() => getInvoiceUpdateColumns(t), [t])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div className="bg-white rounded-md p-4 space-y-2">
            <Typogaphy className="text-primary font-medium">
                {t('history-operation')}
            </Typogaphy>
            <DataTableCustomized
                columns={columns}
                rows={rows}
                rowKey={(row) => row.invoice_update_id}
                pagination={{
                    page: payload.page,
                    pageSize: payload.page_size,
                    total: data?.pagination?.total || 0,
                    onPageChange: (page) => setPayload({ ...payload, page }),
                    onPageSizeChange: (pageSize) =>
                        setPayload({ ...payload, page_size: pageSize }),
                }}
            />
        </div>
    )
}

export default ListInvoiceUpdate
